import { render } from "./CorsePassatePage.vue?vue&type=template&id=0f8470e4&scoped=true"
import script from "./CorsePassatePage.vue?vue&type=script&lang=js"
export * from "./CorsePassatePage.vue?vue&type=script&lang=js"

import "./CorsePassatePage.vue?vue&type=style&index=0&id=0f8470e4&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-partner-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f8470e4"]])

export default __exports__